import { useState } from "react";
import moment from "moment";

export const useReconciliation = () => {
  const [selectedDeadlines, setSelectedDeadlines] = useState([]);
  const [selectedMovements, setSelectedMovements] = useState([]);
  const [selectedMovementDetails, setSelectedMovementDetails] = useState([]);
  const [blockMask, setBlockMask] = useState(false);
  const [startDate, setStartDate] = useState(moment().subtract(2, "y").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().add(2, "y").format("YYYY-MM-DD"));
  const [activeFilters, setActiveFilters] = useState(["all"]);
  const [filtersMovements, setFiltersMovements] = useState({
    type: "all",
    date: [moment().subtract(1, "M"), moment()]
  });
  const [visibleLinkedToDialog, setVisibleLinkedToDialog] = useState(false);
  const [latestLinkedTo, setLatestLinkedTo] = useState(null);
  const [filterIban, setFilterIban] = useState("all");
  const [filterDateRange, setFilterDateRange] = useState(false);

  // funzione per salvare nello stato/array dei filtri attivi solo i filtri che non siano stati già selezionati in precedenza
  // ed eliminare dallo stesso array un filtro già presente che viene nuovamente selezionato
  const activeFiltersSetter = (value) => {
    const activeFiltersCopy = [...activeFilters];
    // se il filtro selezionato è "tutti", questo si comporta come un filtro esclusivo
    if (value === "all") {
      setActiveFilters(["all"]);
      // I filtri incassi e pagamenti, così come tutti i filtri della riga inferiore, sono ad esclusione (uno esclude l'altro o gli altri)
    } else if (value === "collects") {
      if (activeFilters.includes("payments")) {
        const newActiveFilters = activeFiltersCopy.filter((f) => f !== "payments");
        setActiveFilters([...newActiveFilters, value]);
        return null;
      }
    } else if (value === "payments") {
      if (activeFilters.includes("collects")) {
        const newActiveFilters = activeFiltersCopy.filter((f) => f !== "collects");
        setActiveFilters([...newActiveFilters, value]);
        return null;
      }
    } else if (value === "toLink") {
      if (activeFilters.includes("linked") || activeFilters.includes("notLinkable")) {
        const newActiveFilters = activeFiltersCopy.filter((f) => f !== "linked" && f !== "notLinkable");
        setActiveFilters([...newActiveFilters, value]);
        return null;
      }
    } else if (value === "linked") {
      if (activeFilters.includes("toLink") || activeFilters.includes("notLinkable")) {
        const newActiveFilters = activeFiltersCopy.filter((f) => f !== "toLink" && f !== "notLinkable");
        setActiveFilters([...newActiveFilters, value]);
        return null;
      }
    } else if (value === "notLinkable") {
      if (activeFilters.includes("toLink") || activeFilters.includes("linked")) {
        const newActiveFilters = activeFiltersCopy.filter((f) => f !== "toLink" && f !== "linked");
        setActiveFilters([...newActiveFilters, value]);
        return null;
      }
    }
    if (!activeFilters.includes(value) && value !== "all") {
      // rimuovo il filtro "tutti", perché esclude tutti gli altri
      const newActiveFilters = activeFiltersCopy.filter((f) => f !== "all");
      setActiveFilters([...newActiveFilters, value]);
    } else if (activeFilters.includes(value) && value !== "all") {
      const newActiveFilters = activeFiltersCopy.filter((f) => f !== value && f !== "all");
      setActiveFilters([...newActiveFilters]);
    } else {
      return null;
    }
    return null;
  };

  const onFiltersMovementsChange = (type, value) => {
    if (type === "type") {
      setFiltersMovements({ ...filtersMovements, type: value });
      activeFiltersSetter(value);
    }
  };

  const reconciliationHook = {
    selectedDeadlines: selectedDeadlines,
    setSelectedDeadlines: setSelectedDeadlines,
    selectedMovements: selectedMovements,
    setSelectedMovements: setSelectedMovements,
    selectedMovementDetails: selectedMovementDetails,
    setSelectedMovementDetails: setSelectedMovementDetails,
    blockMask: blockMask,
    setBlockMask: setBlockMask,
    startDate: startDate,
    setStartDate: setStartDate,
    endDate: endDate,
    setEndDate: setEndDate,
    activeFilters: activeFilters,
    setActiveFilters: setActiveFilters,
    filtersMovements: filtersMovements,
    setFiltersMovements: setFiltersMovements,
    visibleLinkedToDialog: visibleLinkedToDialog,
    setVisibleLinkedToDialog: setVisibleLinkedToDialog,
    latestLinkedTo: latestLinkedTo,
    setLatestLinkedTo: setLatestLinkedTo,
    onFiltersMovementsChange: onFiltersMovementsChange,
    filterIban: filterIban,
    setFilterIban: setFilterIban,
    filterDateRange: filterDateRange,
    setFilterDateRange: setFilterDateRange
  };

  return reconciliationHook;
};
